module.exports = __webpack_public_path__ + "static/img/20161012-2.4c1629d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20161012-2.jpg
// module id = x66/
// module chunks = 0